import { css } from '@emotion/css';

export const contentWrapper = css`
  background: #ffffff;
  min-height: 920px;
`;
